<template>
  <el-dialog
    title="批量拉黑IP"
    :visible="visible"
    width="600px"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    @update:visible="val => $emit('update:visible', val)"
    @closed="handleClosed"
  >
    <div class="dialog-content">
      <!-- IP列表 -->
      <div class="ip-list-section">
        <div class="section-title">拉黑IP</div>
        <div v-if="ipList.length > 0" class="ip-list">
          <el-tag
            v-for="(ip, index) in ipList"
            :key="index"
            closable
            :disable-transitions="true"
            type="danger"
            style="margin-right: 5px; margin-bottom: 5px"
            @close="removeIp(index)"
          >
            {{ ip }}
          </el-tag>
        </div>
        <div v-else class="empty-tip">暂无IP数据</div>
      </div>

      <!-- 表单 -->
      <el-form
        ref="blackIpFormRef"
        :model="formData"
        :rules="formRules"
        label-position="top"
        size="small"
        style="margin-top: 20px"
      >
        <el-form-item label="限制方式" prop="limit_type">
          <el-select v-model="formData.limit_type" multiple placeholder="请选择" style="width: 300px" clearable>
            <el-option v-for="opt in limitTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="formData.remark"
            type="textarea"
            placeholder="请输入拉黑备注（最多100字）"
            :maxlength="100"
            show-word-limit
            rows="3"
          ></el-input>
        </el-form-item>

        <el-form-item label="同时拉黑IP登录过的账号">
          <el-switch
            v-model="formData.isDisableAccounts"
            active-text="是"
            inactive-text="否"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { loginLogApi } from '@/api/riskControl/loginLog.js'
import { methodOptions } from '@/pages/admin/riskControl/manageList/const'

export default {
  name: 'ManageBlackIpDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedRows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 表单数据
      formData: {
        remark: '',
        isDisableAccounts: false,
        limit_type: [],
      },
      limitTypeOptions: methodOptions,
      // 表单验证规则
      formRules: {
        remark: [
          { required: true, message: '请输入拉黑备注', trigger: 'blur' },
          { required: true, message: '请输入备注（最多100字）', trigger: 'blur' },
        ],
        limit_type: [{ type: 'array', required: true, message: '请选择限制方式', trigger: 'blur' }],
      },
      // 加载状态
      loading: false,
      // IP列表
      ipList: [],
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.initData()
      }
    },
    selectedRows(newVal) {
      if (this.visible) {
        this.ipList = this.extractIps(newVal)
      }
    },
  },
  methods: {
    // 初始化数据
    initData() {
      this.formData = {
        remark: '',
        isDisableAccounts: false,
      }
      this.ipList = this.extractIps(this.selectedRows)
    },

    // 从选中行中提取IP列表
    extractIps(rows) {
      const ips = new Set()
      rows.forEach(row => {
        if (row.login_ip) ips.add(row.login_ip)
        if (row.register_ip) ips.add(row.register_ip)
      })
      return Array.from(ips)
    },

    // 移除IP
    removeIp(index) {
      this.ipList.splice(index, 1)
    },

    // 表单验证
    validateForm() {
      return new Promise((resolve, reject) => {
        this.$refs.blackIpFormRef.validate(valid => {
          if (!valid) {
            reject(new Error('表单验证失败'))
            return
          }

          // 检查 IP 列表是否为空
          if (this.ipList.length === 0) {
            this.$message.error('请至少选择一个 IP')
            reject(new Error('IP 列表为空'))
            return
          }

          resolve()
        })
      })
    },

    // 确认拉黑
    async handleConfirm() {
      try {
        await this.validateForm()
        this.loading = true

        const params = {
          block_type: 2, // 假设1表示IP类型
          reason: this.formData.remark,
          values: this.ipList,
          is_block_player: this.formData.isDisableAccounts,
          limit_type: this.formData.limit_type || [],
        }

        const response = await loginLogApi.createBlacklist(params)
        if (response.code === 0) {
          this.$message.success('拉黑IP成功')
          this.$emit('success')
          this.handleCancel()
        } else {
          this.$message.error('拉黑IP失败：' + (response.msg || '未知错误'))
        }
      } catch (error) {
        if (error.message !== '表单验证失败') {
          this.$message.error('拉黑IP失败：' + error.message)
        }
      } finally {
        this.loading = false
      }
    },

    // 取消
    handleCancel() {
      this.$emit('update:visible', false)
    },

    // 弹窗关闭回调
    handleClosed() {
      // 重置表单
      this.$refs.blackIpFormRef?.resetFields()
      this.formData = {
        limit_type: [],
        remark: '',
        isDisableAccounts: false,
      }
      this.ipList = []
      // 通知父组件弹窗已关闭
      this.$emit('closed')
    },
  },
}
</script>

<style scoped>
.dialog-content {
  padding: 10px 0 20px 0;
}

.ip-list-section {
  margin-bottom: 20px;
}

.section-title {
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
}

.ip-list {
  max-height: 150px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.empty-tip {
  color: #909399;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  text-align: center;
}
</style>
